import React, { useState } from 'react';
import { Icon } from '@pwc/pwc-deals-ui';
import './Accordion.scss';

const Accordion = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={`accordion accordion-only-mobile accordion-${
        isOpen ? 'open' : 'closed'
      }`}
    >
      <button
        type="button"
        onClick={() => {
          setIsOpen(!isOpen);
        }}
        className="accordion-toggle"
        data-testid="accordion-toggle"
      >
        {title}
        <Icon
          name={isOpen ? 'desc' : 'asc'}
          width={21}
          className="outline icon-orange-theme"
        />
      </button>
      <div className="accordion-content">{children}</div>
    </div>
  );
};

export default Accordion;
